import { NgModule } from '@angular/core';
import { DragDropDirective } from './drag-drop/drag-drop';
import { FormulaAutocompleteDirective } from './formula-autocomplete/formula-autocomplete-directive ';
import { GdxTooltipDirective } from './gdx-tooltip/gdx-tooltip';
import { GrdRippleEffectDirective } from './grd-ripple-effect/grd-ripple-effect';
import { NpwpFormatDirective } from './npwp-format/npwp-format';
import { OnlyNumberDirective } from './only-number/only-number';
import { ReplaceTagDirective } from './replace-tag/replace-tag.directive';
import { RupiahFormatDirective } from './rupiah-format/rupiah-format';
import { TextAreaAutosizeDirective } from './text-area-autosize/text-area-autosize';
import { TranslatorDirective } from './translator/translator';
@NgModule({
  declarations: [TextAreaAutosizeDirective,
    GrdRippleEffectDirective,
    NpwpFormatDirective,
    RupiahFormatDirective,
    ReplaceTagDirective,
    TranslatorDirective,
    DragDropDirective,
    OnlyNumberDirective,
    GdxTooltipDirective,
    FormulaAutocompleteDirective,
  ],
  imports: [],
  exports: [TextAreaAutosizeDirective,
    GrdRippleEffectDirective,
    NpwpFormatDirective,
    RupiahFormatDirective,
    ReplaceTagDirective,
    TranslatorDirective,
    DragDropDirective,
    OnlyNumberDirective,
    GdxTooltipDirective,
    FormulaAutocompleteDirective,
  ]
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts